import Box from './Box';

export default function Indicator({ active, small, ...props }) {
	return (
		<Box name="indicator-container" classes={small ? ['small'] : []} {...props}>
			<Box name="indicator-dot" classes={active ? ['active-bg'] : ['not-active-bg']} />
		</Box>
	);
}
